import React, { useCallback, useState, useContext, createContext } from 'react';
import { getDisplayName } from 'recompose';

const defaultValue = {
  title: '',
  backButtonLabel: '',
  onBackButtonClick: null,
  dataTestId: '',
  backButton: null,
  actionsContent: null,
  leftContent: null,
  centerContent: null,
  gutterContent: null,
  setTopbar: () => {},
};

export const TopbarContext = createContext(defaultValue);

export const TopbarContextProvider = (props) => {
  const [state, setState] = useState(defaultValue);

  const handleTopbarSetState = useCallback((props) => {
    setState((prevState) => {
      const newProps = (typeof props === 'function') ? props(prevState) : props;
      const {
        title,
        backButtonLabel,
        onBackButtonClick,
        dataTestId,
        backButton,
        actionsContent,
        leftContent,
        centerContent,
        gutterContent,
      } = newProps;

      return {
        title,
        backButtonLabel,
        onBackButtonClick,
        dataTestId,
        backButton,
        actionsContent,
        leftContent,
        centerContent,
        gutterContent,
      };
    });
  }, []);

  const context = {
    title: state.title,
    backButtonLabel: state.backButtonLabel,
    onBackButtonClick: state.onBackButtonClick,
    dataTestId: state.dataTestId,
    backButton: state.backButton,
    actionsContent: state.actionsContent,
    leftContent: state.leftContent,
    centerContent: state.centerContent,
    gutterContent: state.gutterContent,
    setTopbar: handleTopbarSetState,
  };

  return (
    <TopbarContext.Provider value={context}>
      {props.children}
    </TopbarContext.Provider>
  );
};

export const useTopbar = () => useContext(TopbarContext);

export const withTopbar = () => Component => {
  // We need to forward refs, otherwise refs will incorrectly reference this component and not the underlying component.
  const withTopbarComponent = React.forwardRef((props, ref) => {
    const { setTopbar, ...topbarElements } = useTopbar();

    return (
      <Component ref={ref} setTopbar={setTopbar} topbarElements={topbarElements} {...props} />
    );
  });

  withTopbarComponent.displayName = `withTopbarComponent(${getDisplayName(Component)})`;

  return withTopbarComponent;
};
